import { createSelector } from "reselect";

import { createStatePropertySelector } from "app/pages/workspace/sales/helpers";
import { getTableSelectedItems } from "app/reducers/_reducers/tableSelection.reducer";
import type { RootState } from "single-spa/store/types";

import { selectSalesIntelligenceState } from "../../../store/selectors";

const select = createStatePropertySelector(selectSalesIntelligenceState("common"));

export const selectLegacyWorkspaceId = select("workspaceId");
export const selectLegacyWorkspacesFetching = select("workspacesFetching");
const selectWebsitesData = select("websitesData");
export const selectNotFoundListModalOpen = select("notFoundListModalOpen");
export const selectNotFoundLeadGenModalOpen = select("notFoundLeadGenModalOpen");
export const selectExcelQuota = select("excelQuota");
export const selectIsExcelQuotaLoading = select("isExcelQuotaLoading");
export const selectMultiSelectorPanel = select("multiSelectorPanel");
export const selectNotRevealedContactsIds = select("notRevealedContactsIds");
export const selectContactIdsBeingRevealed = select("contactIdsBeingRevealed");

export const selectWebsiteData = createSelector(
    [selectWebsitesData, <P extends { domain: string }>(_: RootState, props: P) => props.domain],
    (websitesData, domain) => {
        return websitesData[domain];
    },
);

export const selectSelectedDomains = (tableKey: string, tableProperty: string) =>
    createSelector(getTableSelectedItems(tableKey), (domains) => {
        return Array.isArray(domains) ? domains.map((domain) => domain[tableProperty]) : [];
    });

export const selectExcelQuotaRemaining = createSelector(selectExcelQuota, (excelQuota) => {
    return excelQuota.remaining;
});

export const selectRevealedContactsById = select("revealedContactsById");

export const selectIsOnboardingWizardOpened = select("isOnboardingWizardOpened");

export const selectIsExtensionBannerVisible = select("isExtensionBannerVisible");

export const selectIsColumnPickerOpen = select("isColumnPickerOpen");

export const selectActivePageTab = select("activePageTab");
